// Imports: local files.
import ApiClient from '../../services/ApiClient';
import { showSnackbar, dispatchLoading, dispatchSuccess, dispatchError, getAxiosError } from '../../utils/redux';

// Name of property to be used in reducer data.
const toolLevelsName = 'toolLevels';
const toolLevelName = 'toolLevel';

// Action Types: Get All Tool Levels.
export const GET_TOOL_LEVELS_START = 'GET_TOOL_LEVELS_START';
export const GET_TOOL_LEVELS_SUCCESS = 'GET_TOOL_LEVELS_SUCCESS';
export const GET_TOOL_LEVELS_FAILED = 'GET_TOOL_LEVELS_FAILED';
export const GET_TOOL_LEVELS_RESET = 'GET_TOOL_LEVELS_RESET';

// Action Types: Get One Tool Level.
export const GET_TOOL_LEVEL_START = 'GET_TOOL_LEVEL_START';
export const GET_TOOL_LEVEL_SUCCESS = 'GET_TOOL_LEVEL_SUCCESS';
export const GET_TOOL_LEVEL_FAILED = 'GET_TOOL_LEVEL_FAILED';
export const GET_TOOL_LEVEL_RESET = 'GET_TOOL_LEVEL_RESET';

// Action Types: Create Tool Level.
export const CREATE_TOOL_LEVEL_START = 'CREATE_TOOL_LEVEL_START';
export const CREATE_TOOL_LEVEL_SUCCESS = 'CREATE_TOOL_LEVEL_SUCCESS';
export const CREATE_TOOL_LEVEL_FAILED = 'CREATE_TOOL_LEVEL_FAILED';
export const CREATE_TOOL_LEVEL_RESET = 'CREATE_TOOL_LEVEL_RESET';

// Action Types: Update Tool Level.
export const UPDATE_TOOL_LEVEL_START = 'UPDATE_TOOL_LEVEL_START';
export const UPDATE_TOOL_LEVEL_SUCCESS = 'UPDATE_TOOL_LEVEL_SUCCESS';
export const UPDATE_TOOL_LEVEL_FAILED = 'UPDATE_TOOL_LEVEL_FAILED';
export const UPDATE_TOOL_LEVEL_RESET = 'UPDATE_TOOL_LEVEL_RESET';

// Action Types: Delete Tool Level.
export const DELETE_TOOL_LEVEL_START = 'DELETE_TOOL_LEVEL_START';
export const DELETE_TOOL_LEVEL_SUCCESS = 'DELETE_TOOL_LEVEL_SUCCESS';
export const DELETE_TOOL_LEVEL_FAILED = 'DELETE_TOOL_LEVEL_FAILED';
export const DELETE_TOOL_LEVEL_RESET = 'DELETE_TOOL_LEVEL_RESET';

// Action Creators: Get All Tools.
const getToolLevelsStart = (payload) => ({ type: GET_TOOL_LEVELS_START, payload });
const getToolLevelsSuccess = (payload) => ({ type: GET_TOOL_LEVELS_SUCCESS, payload });
const getToolLevelsFailed = (payload) => ({ type: GET_TOOL_LEVELS_FAILED, payload });
const getToolLevelsReset = () => ({ type: GET_TOOL_LEVELS_RESET });

// Action Creators: Get One Tool.
const getToolLevelStart = (payload) => ({ type: GET_TOOL_LEVEL_START, payload });
const getToolLevelSuccess = (payload) => ({ type: GET_TOOL_LEVEL_SUCCESS, payload });
const getToolLevelFailed = (payload) => ({ type: GET_TOOL_LEVEL_FAILED, payload });
const getToolLevelReset = () => ({ type: GET_TOOL_LEVEL_RESET });

// Action Creators: Create Tool.
const createToolLevelStart = (payload) => ({ type: CREATE_TOOL_LEVEL_START, payload });
const createToolLevelSuccess = (payload) => ({ type: CREATE_TOOL_LEVEL_SUCCESS, payload });
const createToolLevelFailed = (payload) => ({ type: CREATE_TOOL_LEVEL_FAILED, payload });
const createToolLevelReset = () => ({ type: CREATE_TOOL_LEVEL_RESET });

// Action Creators: Update Tool.
const updateToolLevelStart = (payload) => ({ type: UPDATE_TOOL_LEVEL_START, payload });
const updateToolLevelSuccess = (payload) => ({ type: UPDATE_TOOL_LEVEL_SUCCESS, payload });
const updateToolLevelFailed = (payload) => ({ type: UPDATE_TOOL_LEVEL_FAILED, payload });
const updateToolLevelReset = () => ({ type: UPDATE_TOOL_LEVEL_RESET });

// Action Creators: Delete Tool.
const deleteToolLevelStart = (payload) => ({ type: DELETE_TOOL_LEVEL_START, payload });
const deleteToolLevelSuccess = (payload) => ({ type: DELETE_TOOL_LEVEL_SUCCESS, payload });
const deleteToolLevelFailed = (payload) => ({ type: DELETE_TOOL_LEVEL_FAILED, payload });
const deleteToolLevelReset = () => ({ type: DELETE_TOOL_LEVEL_RESET });

// Actions: Get All Tool Levels.
export const getToolLevels = (payload, options = {}) => {
  const { page, limit, pagination, name, noParentsTool, parent } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getToolLevelsStart);

      const query = { page, limit, pagination, name, noParentsTool, parent };
      const result = await ApiClient.get('/toollevels', { params: query });
      if (result.data?.success) {
        const { toollevels } = result.data?.data;
        dispatchSuccess(dispatch, getToolLevelsSuccess, toollevels, 'toollevels');
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getToolLevelsFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getToolLevelsFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Get All Tools.
export const clearToolLevels = () => getToolLevelsReset();

// Actions: Get One Tool Level.
export const getToolLevel = (payload, options = {}) => {
  const { toolId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getToolLevelStart);

      const result = await ApiClient.get(`/toollevels/${toolId}`);
      if (result.data?.success) {
        const { toolLevel } = result.data?.data;
        dispatchSuccess(dispatch, getToolLevelSuccess, toolLevel, toolLevelName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getToolLevelFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getToolLevelFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Get One Tool.
export const clearToolLevel = () => getToolLevelReset();

// Actions: Create Tool Level.
export const createToolLevel = (payload, options = {}) => {
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, createToolLevelStart);

      const result = await ApiClient.post(`/toollevels`, payload);
      if (result.data?.success) {
        const { toolLevel } = result.data?.data;
        dispatchSuccess(dispatch, createToolLevelSuccess, toolLevel, toolLevelName);
        showSnackbar(dispatch, 'Tool created successfully!', 'success');
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, createToolLevelFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, createToolLevelFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Created Tool.
export const clearCreatedToolLevel = () => createToolLevelReset();

// Actions: Update Tool.
export const updateToolLevel = (payload, options = {}) => {
  const { toolLevelId, name, parent } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, updateToolLevelStart);

      const result = await ApiClient.put(`/toollevels/${toolLevelId}`, { name, parent });
      if (result.data?.success) {
        const { toolLevel } = result.data?.data;
        dispatchSuccess(dispatch, updateToolLevelSuccess, toolLevel, toolLevelName);
        showSnackbar(dispatch, 'Tool Level updated successfully!', 'success');
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, updateToolLevelFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, updateToolLevelFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Updated Tool.
export const clearUpdatedToolLevel = () => updateToolLevelReset();

// Actions: Delete Tool Level.
export const deleteToolLevel = (payload, options = {}) => {
  const { toolLevelId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, deleteToolLevelStart);

      const result = await ApiClient.delete(`/toollevels/${toolLevelId}`);
      if (result.data?.success) {
        const { toolLevel } = result.data?.data;
        dispatchSuccess(dispatch, deleteToolLevelSuccess, toolLevel, toolLevelName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, deleteToolLevelFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, deleteToolLevelFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Deleted Tool Level.
export const clearDeletedToolLevel = () => deleteToolLevelReset();
